import {Routes} from "@angular/router";
import {HomePageComponent} from "./home-page.component";
//import {TexturesPageComponent} from "./textures-page.document";
import {HomePageRootComponent} from "./home-page-root.component";
import {ProfileUtilsPageComponent} from "./profile-utils-page.component";

export const HomePageRoutes: Routes = [
  {
    path: "",
    component: HomePageRootComponent,
    data: { name: "Главная" },
    children: [
      {
        path: "",
        component: HomePageComponent,
        data: { name: "Оч. главная" },
      },
      {
        path: "profile-utils",
        component: ProfileUtilsPageComponent,
        data: { name: "Профайл-тулзы" },
      }
    ]
  }
];



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/home/home-page-routing.module.ts